import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { CustomInputNumber, CustomInputNumberProps } from '../../../custom_shared/components';
import { WithInput } from '../../types';
import { Regex } from '../../../custom_shared/misc';
import { TypeUtils } from '../../../common/misc';
import { useInputHighlighting, useGlobalInputState } from '../../hooks';

export type CustomInputNumberWrapperProps = WithInput<CustomInputNumberProps>;

const CustomInputNumberWrapper: React.FC<CustomInputNumberWrapperProps> = (props: CustomInputNumberWrapperProps) => {
    const { input, ...rest } = props;

    const [containerRef, setContainerRef] = React.useState<React.RefObject<HTMLDivElement> | null>(null);

    const { containerStyle } = useInputHighlighting(input, containerRef);

    const globalInputState = useGlobalInputState(input, props);

    return (
        <CustomInputNumber
            containerStyle={containerStyle}
            getContainerRef={setContainerRef}
            parser={value => (TypeUtils.isString(value) ? value.replace(Regex.commaRegex, '') : '')}
            {...rest}
            {...globalInputState}
        />
    );
};

export default observer(CustomInputNumberWrapper);
